<template>
    <!-- 搜索菜单 -->
    <div class="search-menu">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="综合" name="total"></el-tab-pane>
            <el-tab-pane label="诗人" name="poet"></el-tab-pane>
            <el-tab-pane label="标题" name="title"></el-tab-pane>
            <el-tab-pane label="正文" name="content"></el-tab-pane>
            <el-tab-pane label="朝代" name="dynasty"></el-tab-pane>
            <el-tab-pane label="标签" name="tag"></el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    // 使用命名空间之后的简化方式
    import {createNamespacedHelpers } from "vuex";
    const { mapState, mapMutations } = createNamespacedHelpers('search');

    export default {
        name: "SearchMenu",
        computed:{
            ...mapState(['input']),
            activeName:{
                get(){
                    return this.$store.state.search.activeName;
                },
                set(newVal){
                    this.$store.commit("search/updateActiveName",newVal);
                }
            }
        },
        methods: {
            /**
             * @author 孟祥龙
             * @Desc TODO 处理点击事件
             * @date 2021/5/11 10:20
             * @return
             */
            handleClick() {
                this.$router.push('/search/' + this.activeName + '/' + this.input);
            }
        }
    }
</script>

<style  lang="less">
    .search-menu{
        .el-tabs__nav-scroll{
            display: flex;
            justify-content: center;
            .el-tabs__nav{
                display: flex;
                justify-content: center;
                margin: 0 auto;

                .el-tabs__item{
                    font-size: 17px !important;
                    font-weight: bold;
                }
            }
        }

    }
</style>